import { createAction } from 'redux-actions';

import fetch from 'features/common/fetch';
import user from 'features/views/user';

import * as types from './actionTypes';

export const setRegions = createAction(types.SET_REGIONS, (regions) => ({ regions }));

export const getRegions = (campaignId) => (dispatch, getState) => {
	dispatch(
		fetch.actions.post(fetch.constants.urls.dashboardRegionsOfCampaign, {
			body: {
				campaignId,
				userRole: user.selectors.getCurrentRole(getState()),
			},
			onSuccess: [
				(response) => () => {
					if (!response.body) return;
					dispatch(setRegions(response.body));
				},
			],
		}),
	);
};

export const reload = () => (dispatch, getState) => {
	const { body } = fetch.selectors.getLastRequest(fetch.constants.urls.dashboardRegionsOfCampaign)(getState());
	dispatch(getRegions(body.campaignId));
};
